/* eslint-disable @typescript-eslint/no-explicit-any */
import tw, { styled } from 'twin.macro'

import { inputErrorStyles, inputWrapperErrorStyles } from '../sharedStyles'

export const InputWrapper = styled.div(
  ({ $hasError, $readOnly }: { $hasError?: any; $readOnly?: boolean }) => [
    !$readOnly && tw`border-b`,
    $hasError && inputWrapperErrorStyles,
    !$hasError &&
      !$readOnly &&
      tw`
        transition-colors duration-100
        border-transparent
        hover:border-brand-emphasis focus-within:border-brand-emphasis
      `,
  ],
)

export const StyledInput = styled.input<{ $hasError?: any }>(
  ({ $hasError, readOnly }) => [
    tw`
    font-brand font-medium text-3xl leading-5
    py-1
    block
    w-full
    border-none
    appearance-none
    rounded-md
    min-w-0
    text-default-neutral
    bg-default-subdued

    focus:outline-none
  `,
    $hasError && inputErrorStyles,
    readOnly && tw`cursor-default`,
  ],
)
